import React from "react";
import {useSelector} from 'react-redux';
import {makeStyles} from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(theme => ({
    root: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        background: '#20356C',
        outline: 'none',
        padding: '1rem',
        color: 'white',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'center',
        overflow: 'hidden',
        borderRadius: 4,
        boxShadow: '2px 2px .5rem rgba(0, 0, 0, .25)'
    },
    spinner: {
        marginRight: '.5rem',
        color: '#FFCB05 !important'
    }
}));

export default function LoadingModal() {
    const classes = useStyles();
    const isLoading = useSelector(state => state.isLoading);

    return (
        <Modal open={isLoading}>
            <div className={classes.root}>
                <CircularProgress size='1.5rem' className={classes.spinner} />
                <span>Carregando, aguarde...</span>
            </div>
        </Modal>
    );
}